import React, { useState, useContext, useEffect } from "react";
import * as XLSX from "xlsx/xlsx.mjs";
import MUIDataTable from "mui-datatables";
import { useQuery } from "@apollo/react-hooks";
import { confirmMutations, confirmQueries } from "../../resolvers";
import { ConfirmContext } from "./contexts";
import {
  CustomToolbar,
  Loading,
  CustomToolbarSelectWithUpdate,
  textLabels,
} from "../../../components";
import _, { isArray } from "lodash";
import moment from "moment";
import { handleExporttoExcel } from "../../components";
import { Dialog } from "./component";
import PlaylistAddIcon from "@material-ui/icons/PlaylistAdd";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import randomize from "randomatic";

const PageList = ({ currentcompany }) => {
  moment.locale();
  const { state, setState } = useContext(ConfirmContext);
  const [variables, setVariables] = useState({
    data: {
      company: currentcompany.id,
      isActive: true,
    },
  });
  const [excelData, setExcelData] = useState([]);
  const [uploadLoading, setUploadLoading] = useState(false);
  const changeState = (value) => {
    setState({ ...state, ...value });
  };

  const handleAdd = () => {
    changeState({
      page: "add",
      addUpdate: {
        data: {
          company: "",
          serino: "",
          code: "",
          product: "",
          dimensions: "",
          productPalace: "",
          productDate: "",
          description: "",
        },
      },
    });
  };

  const { loading, data, refetch } = useQuery(confirmQueries.ALL, {
    onCompleted({ Confirms }) {
      changeState({
        pageList: {
          ...state.pageList,
          data: Confirms,
        },
      });
      setInitialState();
    },
    variables,
    onError(err) {
      console.log(err);
    },
  });
  //console.log(data);
  const handleRefetch = () => {
    refetch();
  };

  const HandleCustomButtom = () => {
    return (
      <label htmlFor="file">
        <input
          id="file"
          type="file"
          multiple
          style={{ position: "fixed", top: "-100em" }}
          onChange={(e) => handleUpload(e.target.files)}
        />
        <Tooltip title="Excel'den Kayıt Aktar">
          <IconButton component="span">
            <PlaylistAddIcon />
          </IconButton>
        </Tooltip>
      </label>
    );
  };
  const [initialState, setInitialState] = useState(data ? data.Confirms : []);

  const changeInitialState = (data) => {
    setInitialState(data);
  };

  const handleDownload = async () => {
    const sheet = "Anzer Web Kayıtları";
    const file = moment().format("DD.MM.YYYY").toString();
    const column = [
      { header: "Seri No", key: "serino", width: 15 },
      { header: "Kod", key: "code", width: 35 },
      { header: "Dolum Yapılan Kooperatif", key: "product", width: 30 },
      {
        header: "Dolum Yapılan Ambalaj Boyutu (gr)",
        key: "dimensions",
        width: 35,
      },
      { header: "Dolum Yeri", key: "productPalace", width: 20 },
      { header: "Dolum Tarihi", key: "productDate", width: 20 },
      { header: "Açıklama", key: "description", width: 20 },
    ];
    const rows = _.orderBy(initialState, ["productDate"], ["desc"]);
    const row = await rows.map((x) => {
      let type = "";
      if (isArray(x.type)) {
        x.type.forEach((e) => {
          type += e + ", ";
        });
      }
      return {
        serino: x.serino,
        code: x.code,
        product: x.product,
        dimensions: x.dimensions,
        productPalace: x.productPalace,
        productDate: moment(x.productDate).format("DD.MM.YYYY"),
        description: x.description,
      };
    });
    handleExporttoExcel(file, sheet, column, row);
  };

  const columns = [
    {
      name: "id",
      label: "id",
      options: {
        display: "excluded",
        filter: false,
        sort: false,
      },
    },
    {
      name: "serino",
      label: "No",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "code",
      label: "Kod",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "product",
      label: "Dolum Yapılan Kooperatif",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "dimensions",
      label: "Dolum Yapılan Ambalaj Boyutu (gr)",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "productPalace",
      label: "Dolum Yeri",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "productDate",
      label: "Dolum Tarihi",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return value ? moment(value).format("DD.MM.YYYY") : "";
        },
      },
    },
    {
      name: "description",
      label: "Açıklama",
      options: {
        filter: false,
        sort: true,
      },
    },
  ];

  const options = {
    filter: true,
    print: false,
    download: false,
    viewColumns: true,
    responsive: "scrollMaxHeight",
    fixedHeader: true,
    customToolbar: () => (
      <CustomToolbar
        handleDownload={handleDownload}
        handleAdd={handleAdd}
        handleRefetch={handleRefetch}
        HandleCustomButtom={HandleCustomButtom}
      />
    ),
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <CustomToolbarSelectWithUpdate
        selectedRows={selectedRows}
        displayData={displayData}
        setSelectedRows={setSelectedRows}
        mutation={confirmMutations.DELETE}
        query={{
          query: confirmQueries.ALL,
          variables,
        }}
        queryData="Confirms"
        deleteMethod="ConfirmRemove"
        changeState={changeState}
        changeInitialState={changeInitialState}
      />
    ),
    textLabels,
  };

  const handleUpload = (acceptedFiles) => {
    const files = acceptedFiles,
      f = files[0];
    const reader = new FileReader();
    reader.onload = function (e) {
      const data = e.target.result;
      const readedData = XLSX.read(data, { type: "binary" });
      const wsname = readedData.SheetNames[0];
      const ws = readedData.Sheets[wsname];
      const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 });
      const ExcelData = [];
      for (let i = 1; i < dataParse.length; i++) {
        const x = dataParse[i];
        const y = {
          serino: x[0],
          code:x[1], //randomize('?', 7, {chars: 'ABCDEFGHIUmnopqrsVWXYZ0123456JKLMNOPQRST789abcdefghijkltuvwxyz'}),
          product: x[2],
          dimensions: x[3],
          productPalace: x[4],
          productDate: x[5],
          description: x[6],
        };
        ExcelData.push(y);
      }
      setExcelData(ExcelData);
    };
    reader.readAsBinaryString(f);
    setState({ ...state, options: { ...state.options, dialog: true } });
  };

  useEffect(() => {
    changeState({
      pageList: {
        ...state.pageList,
        variables,
      },
    });
  }, [variables]);

  useEffect(() => {
    if (data) {
      setInitialState(data.Confirms);
    }
  }, [data]);

  useEffect(() => {
    if (state.refetch) {
      refetch();
      changeState({ refetch: false });
    }
  }, [state.refetch]);

  if (loading || uploadLoading) return <Loading />;
  return (
    <div>
      <Dialog
        excelData={excelData}
        setExcelData={setExcelData}
        refetch={refetch}
        currentcompany={currentcompany}
        setUploadLoading={setUploadLoading}
      />
      <MUIDataTable
        title={"Anzer Bal Kayıtları"}
        data={_.orderBy(initialState, ["productDate"], ["desc"])}
        columns={columns}
        options={options}
      />
    </div>
  );
};

export default PageList;
